import { Button, Row, Col, Typography, Input, Card, message } from "antd";
import { useState } from "react";
import { TextSqlHeader } from "./textSqlHeader";
import { ArrowRightOutlined, DownloadOutlined } from '@ant-design/icons';
import axios from "axios";
import {LoginWrapper} from "../LoginWrapper/login";

const { Text, Title } = Typography;

const BuzzReportsDownloadBotComponent = () => {
  const [requestId, setRequestId] = useState("");
  const [showDownloadBox, setShowDownloadBox] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRequestSubmit = async () => {
    if (requestId.trim()) {
      setShowDownloadBox(true);
    }
  };

  const handleDownload = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        "https://era.easebuzz.in/api/buzz-reports-download/",
        { request_id: requestId },
        { responseType: "blob" } // To handle binary file response
      );

      // Create a blob URL and trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${requestId}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      message.success("File downloaded successfully!");
    } catch (error) {
      message.error("Failed to download file. Please try again.");
      console.error("Download error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row className="background-container" justify="center" style={{ padding: "20px" }}>
      <TextSqlHeader />
      <Col span={12}>
        <Title level={3} style={{ textAlign: "center", marginBottom: "20px" }}>
          BuzzReports Download
        </Title>
        <Input
          placeholder="Enter Request ID"
          value={requestId}
          onChange={(e) => setRequestId(e.target.value)}
          style={{ marginBottom: "10px", borderRadius: "8px" }}
        />
        <Button
          type="primary"
          icon={<ArrowRightOutlined />}
          onClick={handleRequestSubmit}
          style={{ borderRadius: "8px" }}
        >
          Submit
        </Button>

        {showDownloadBox && (
          <Card
            style={{
              marginTop: "20px",
              borderRadius: "12px",
              textAlign: "center",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Text>Your request is ready. Click below to download the file.</Text>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              style={{ marginTop: "10px", borderRadius: "8px" }}
              loading={loading}
              onClick={handleDownload}
            >
              Download File
            </Button>
          </Card>
        )}
      </Col>
    </Row>
  );
};

export const BuzzReportsDownloadBot = () => {
  return (
    <LoginWrapper>
      < BuzzReportsDownloadBotComponent/>
    </LoginWrapper>
  );
};

